import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
} from "../../../../ui/AlertDialog/AlertDialog";
import { Button } from "../../../../ui/Button";
import { t } from "i18next";
import React, { useEffect } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import { useRefreshPersons } from "../../../../hooks/useRefreshStateHooks/useRefreshPersons";

type Props = {
  changeId: string;
  personId: string | undefined;
  isDeleteOpen: boolean;
  closeModal: Function;
  updateList: Function;
};

const DeleteChange = ({ changeId, personId, isDeleteOpen, closeModal, updateList }: Props) => {
  const [{ response: deleteResponse, isLoading: deleteIsLoading, error: deleteError }, doFetchItemDelete] = useFetch(
    `/directories/personnels/${personId}/changes/${changeId}`
  );

  const doFetchPersons = useRefreshPersons();
  useEffect(() => {
    if (isDeleteOpen) {
      updateList();
      doFetchPersons();
      closeModal();
    }
  }, [deleteResponse]);

  const onDelete = () => {
    doFetchItemDelete({
      method: "DELETE",
    });
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }} className="gap-0">
        <AlertDialogTitle>Удалить изменение</AlertDialogTitle>
        <AlertDialogDescription>Вы уверены, что хотите удалить изменение?</AlertDialogDescription>

        <div className="flex justify-between mt-4">
          <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>
            {t("delete")}
          </Button>
          <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteChange;
